// extracted by mini-css-extract-plugin
export default {"content":"CustomerSupport_content__3SYvC","label":"CustomerSupport_label__CxPpu","dot":"CustomerSupport_dot__sFUkb"};